module.exports = __webpack_public_path__ + "img/15.fe8abfce.webp";